import React, { useState, useEffect } from 'react'
import { initialise as initAuthClient } from '@babylon/auth0'
import { useAuth0Config } from '@/redux/selectors'
import Loading from './components/Loading'

const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const config = useAuth0Config()

  useEffect(() => {
    const initialise = async () => {
      await initAuthClient(config)

      setLoading(false)
    }
    initialise()
  }, [config])

  return loading ? <Loading /> : children
}

export default AuthProvider
